@file:OptIn(InternalResourceApi::class)

package dungeonamigo.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dungeonamigo.shared.generated.resources/"

@delegate:ResourceContentHash(824_573_836)
internal val Res.drawable.avatar_dragonborn_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_464_086)
internal val Res.drawable.avatar_dragonborn_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_049_498_501)
internal val Res.drawable.avatar_dragonborn_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-727_461_467)
internal val Res.drawable.avatar_dragonborn_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_037_391_527)
internal val Res.drawable.avatar_dragonborn_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-943_983_764)
internal val Res.drawable.avatar_dragonborn_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(347_673_015)
internal val Res.drawable.avatar_dragonborn_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-914_807_013)
internal val Res.drawable.avatar_dragonborn_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_058_833_036)
internal val Res.drawable.avatar_dragonborn_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_331_820_092)
internal val Res.drawable.avatar_dragonborn_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_970_604_341)
internal val Res.drawable.avatar_dragonborn_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_989_329_772)
internal val Res.drawable.avatar_dragonborn_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dragonborn_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dragonborn_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(134_397_610)
internal val Res.drawable.avatar_dwarf_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-922_840_796)
internal val Res.drawable.avatar_dwarf_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_086_947_025)
internal val Res.drawable.avatar_dwarf_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_887_877_469)
internal val Res.drawable.avatar_dwarf_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-146_703_981)
internal val Res.drawable.avatar_dwarf_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(578_350_328)
internal val Res.drawable.avatar_dwarf_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-439_540_031)
internal val Res.drawable.avatar_dwarf_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-446_708_363)
internal val Res.drawable.avatar_dwarf_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_761_016_949)
internal val Res.drawable.avatar_dwarf_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_919_389_760)
internal val Res.drawable.avatar_dwarf_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-696_263_625)
internal val Res.drawable.avatar_dwarf_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_197_178_983)
internal val Res.drawable.avatar_dwarf_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_dwarf_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_dwarf_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-702_688_362)
internal val Res.drawable.avatar_elf_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(729_532_289)
internal val Res.drawable.avatar_elf_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_382_135_501)
internal val Res.drawable.avatar_elf_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_780_694_794)
internal val Res.drawable.avatar_elf_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_107_776_172)
internal val Res.drawable.avatar_elf_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_891_789_066)
internal val Res.drawable.avatar_elf_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_199_688_421)
internal val Res.drawable.avatar_elf_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_649_901_488)
internal val Res.drawable.avatar_elf_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_345_362_076)
internal val Res.drawable.avatar_elf_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(590_685_095)
internal val Res.drawable.avatar_elf_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_245_527_270)
internal val Res.drawable.avatar_elf_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(519_782_443)
internal val Res.drawable.avatar_elf_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_elf_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_elf_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_289_051_024)
internal val Res.drawable.avatar_gnome_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(923_493_038)
internal val Res.drawable.avatar_gnome_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_676_162_261)
internal val Res.drawable.avatar_gnome_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_271_468_416)
internal val Res.drawable.avatar_gnome_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(118_887_675)
internal val Res.drawable.avatar_gnome_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_991_930_509)
internal val Res.drawable.avatar_gnome_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_005_258_876)
internal val Res.drawable.avatar_gnome_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-581_876_131)
internal val Res.drawable.avatar_gnome_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_752_915_350)
internal val Res.drawable.avatar_gnome_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_338_792_931)
internal val Res.drawable.avatar_gnome_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_792_977_021)
internal val Res.drawable.avatar_gnome_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_135_176_147)
internal val Res.drawable.avatar_gnome_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_gnome_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_gnome_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(625_510_669)
internal val Res.drawable.avatar_half_orc_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(383_687_733)
internal val Res.drawable.avatar_half_orc_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-637_099_025)
internal val Res.drawable.avatar_half_orc_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_364_215_310)
internal val Res.drawable.avatar_half_orc_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(51_101_756)
internal val Res.drawable.avatar_half_orc_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_328_769_654)
internal val Res.drawable.avatar_half_orc_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-934_958_271)
internal val Res.drawable.avatar_half_orc_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(400_004_755)
internal val Res.drawable.avatar_half_orc_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_799_757_307)
internal val Res.drawable.avatar_half_orc_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-742_280_652)
internal val Res.drawable.avatar_half_orc_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_031_947_599)
internal val Res.drawable.avatar_half_orc_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_095_510_478)
internal val Res.drawable.avatar_half_orc_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_half_orc_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_half_orc_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-601_310_873)
internal val Res.drawable.avatar_halfling_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_442_668_222)
internal val Res.drawable.avatar_halfling_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_546_911_319)
internal val Res.drawable.avatar_halfling_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_549_182_014)
internal val Res.drawable.avatar_halfling_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_515_466_608)
internal val Res.drawable.avatar_halfling_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_223_443_733)
internal val Res.drawable.avatar_halfling_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_339_405_360)
internal val Res.drawable.avatar_halfling_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_710_867_034)
internal val Res.drawable.avatar_halfling_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_050_520_660)
internal val Res.drawable.avatar_halfling_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(294_827_802)
internal val Res.drawable.avatar_halfling_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(675_086_939)
internal val Res.drawable.avatar_halfling_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(241_826_480)
internal val Res.drawable.avatar_halfling_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_halfling_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_halfling_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_486_309_007)
internal val Res.drawable.avatar_human_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_303_200_107)
internal val Res.drawable.avatar_human_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-799_343_064)
internal val Res.drawable.avatar_human_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_217_220_299)
internal val Res.drawable.avatar_human_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_256_372_311)
internal val Res.drawable.avatar_human_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(150_219_980)
internal val Res.drawable.avatar_human_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_029_420_107)
internal val Res.drawable.avatar_human_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-801_529_586)
internal val Res.drawable.avatar_human_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_442_810_427)
internal val Res.drawable.avatar_human_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_262_014_907)
internal val Res.drawable.avatar_human_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(61_747_306)
internal val Res.drawable.avatar_human_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(366_035_864)
internal val Res.drawable.avatar_human_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_human_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_human_wizard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(712_833_225)
internal val Res.drawable.avatar_tiefling_barbarian: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_barbarian", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_barbarian.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_472_560_878)
internal val Res.drawable.avatar_tiefling_bard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_bard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_bard.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_124_535_589)
internal val Res.drawable.avatar_tiefling_cleric: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_cleric", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_cleric.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_701_816_909)
internal val Res.drawable.avatar_tiefling_druid: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_druid", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_druid.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(517_029_874)
internal val Res.drawable.avatar_tiefling_fighter: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_fighter", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_fighter.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_845_217_055)
internal val Res.drawable.avatar_tiefling_monk: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_monk", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_monk.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(28_279_542)
internal val Res.drawable.avatar_tiefling_paladin: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_paladin", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_paladin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_132_684_421)
internal val Res.drawable.avatar_tiefling_ranger: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_ranger", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_ranger.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_011_228_742)
internal val Res.drawable.avatar_tiefling_rogue: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_rogue", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_rogue.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_980_821_283)
internal val Res.drawable.avatar_tiefling_sorcerer: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_sorcerer", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_sorcerer.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(464_488_487)
internal val Res.drawable.avatar_tiefling_warlock: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_warlock", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_warlock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_997_041_471)
internal val Res.drawable.avatar_tiefling_wizard: DrawableResource by lazy {
      DrawableResource("drawable:avatar_tiefling_wizard", setOf(
        ResourceItem(setOf(), "${MD}drawable/avatar_tiefling_wizard.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("avatar_dragonborn_barbarian", Res.drawable.avatar_dragonborn_barbarian)
  map.put("avatar_dragonborn_bard", Res.drawable.avatar_dragonborn_bard)
  map.put("avatar_dragonborn_cleric", Res.drawable.avatar_dragonborn_cleric)
  map.put("avatar_dragonborn_druid", Res.drawable.avatar_dragonborn_druid)
  map.put("avatar_dragonborn_fighter", Res.drawable.avatar_dragonborn_fighter)
  map.put("avatar_dragonborn_monk", Res.drawable.avatar_dragonborn_monk)
  map.put("avatar_dragonborn_paladin", Res.drawable.avatar_dragonborn_paladin)
  map.put("avatar_dragonborn_ranger", Res.drawable.avatar_dragonborn_ranger)
  map.put("avatar_dragonborn_rogue", Res.drawable.avatar_dragonborn_rogue)
  map.put("avatar_dragonborn_sorcerer", Res.drawable.avatar_dragonborn_sorcerer)
  map.put("avatar_dragonborn_warlock", Res.drawable.avatar_dragonborn_warlock)
  map.put("avatar_dragonborn_wizard", Res.drawable.avatar_dragonborn_wizard)
  map.put("avatar_dwarf_barbarian", Res.drawable.avatar_dwarf_barbarian)
  map.put("avatar_dwarf_bard", Res.drawable.avatar_dwarf_bard)
  map.put("avatar_dwarf_cleric", Res.drawable.avatar_dwarf_cleric)
  map.put("avatar_dwarf_druid", Res.drawable.avatar_dwarf_druid)
  map.put("avatar_dwarf_fighter", Res.drawable.avatar_dwarf_fighter)
  map.put("avatar_dwarf_monk", Res.drawable.avatar_dwarf_monk)
  map.put("avatar_dwarf_paladin", Res.drawable.avatar_dwarf_paladin)
  map.put("avatar_dwarf_ranger", Res.drawable.avatar_dwarf_ranger)
  map.put("avatar_dwarf_rogue", Res.drawable.avatar_dwarf_rogue)
  map.put("avatar_dwarf_sorcerer", Res.drawable.avatar_dwarf_sorcerer)
  map.put("avatar_dwarf_warlock", Res.drawable.avatar_dwarf_warlock)
  map.put("avatar_dwarf_wizard", Res.drawable.avatar_dwarf_wizard)
  map.put("avatar_elf_barbarian", Res.drawable.avatar_elf_barbarian)
  map.put("avatar_elf_bard", Res.drawable.avatar_elf_bard)
  map.put("avatar_elf_cleric", Res.drawable.avatar_elf_cleric)
  map.put("avatar_elf_druid", Res.drawable.avatar_elf_druid)
  map.put("avatar_elf_fighter", Res.drawable.avatar_elf_fighter)
  map.put("avatar_elf_monk", Res.drawable.avatar_elf_monk)
  map.put("avatar_elf_paladin", Res.drawable.avatar_elf_paladin)
  map.put("avatar_elf_ranger", Res.drawable.avatar_elf_ranger)
  map.put("avatar_elf_rogue", Res.drawable.avatar_elf_rogue)
  map.put("avatar_elf_sorcerer", Res.drawable.avatar_elf_sorcerer)
  map.put("avatar_elf_warlock", Res.drawable.avatar_elf_warlock)
  map.put("avatar_elf_wizard", Res.drawable.avatar_elf_wizard)
  map.put("avatar_gnome_barbarian", Res.drawable.avatar_gnome_barbarian)
  map.put("avatar_gnome_bard", Res.drawable.avatar_gnome_bard)
  map.put("avatar_gnome_cleric", Res.drawable.avatar_gnome_cleric)
  map.put("avatar_gnome_druid", Res.drawable.avatar_gnome_druid)
  map.put("avatar_gnome_fighter", Res.drawable.avatar_gnome_fighter)
  map.put("avatar_gnome_monk", Res.drawable.avatar_gnome_monk)
  map.put("avatar_gnome_paladin", Res.drawable.avatar_gnome_paladin)
  map.put("avatar_gnome_ranger", Res.drawable.avatar_gnome_ranger)
  map.put("avatar_gnome_rogue", Res.drawable.avatar_gnome_rogue)
  map.put("avatar_gnome_sorcerer", Res.drawable.avatar_gnome_sorcerer)
  map.put("avatar_gnome_warlock", Res.drawable.avatar_gnome_warlock)
  map.put("avatar_gnome_wizard", Res.drawable.avatar_gnome_wizard)
  map.put("avatar_half_orc_barbarian", Res.drawable.avatar_half_orc_barbarian)
  map.put("avatar_half_orc_bard", Res.drawable.avatar_half_orc_bard)
  map.put("avatar_half_orc_cleric", Res.drawable.avatar_half_orc_cleric)
  map.put("avatar_half_orc_druid", Res.drawable.avatar_half_orc_druid)
  map.put("avatar_half_orc_fighter", Res.drawable.avatar_half_orc_fighter)
  map.put("avatar_half_orc_monk", Res.drawable.avatar_half_orc_monk)
  map.put("avatar_half_orc_paladin", Res.drawable.avatar_half_orc_paladin)
  map.put("avatar_half_orc_ranger", Res.drawable.avatar_half_orc_ranger)
  map.put("avatar_half_orc_rogue", Res.drawable.avatar_half_orc_rogue)
  map.put("avatar_half_orc_sorcerer", Res.drawable.avatar_half_orc_sorcerer)
  map.put("avatar_half_orc_warlock", Res.drawable.avatar_half_orc_warlock)
  map.put("avatar_half_orc_wizard", Res.drawable.avatar_half_orc_wizard)
  map.put("avatar_halfling_barbarian", Res.drawable.avatar_halfling_barbarian)
  map.put("avatar_halfling_bard", Res.drawable.avatar_halfling_bard)
  map.put("avatar_halfling_cleric", Res.drawable.avatar_halfling_cleric)
  map.put("avatar_halfling_druid", Res.drawable.avatar_halfling_druid)
  map.put("avatar_halfling_fighter", Res.drawable.avatar_halfling_fighter)
  map.put("avatar_halfling_monk", Res.drawable.avatar_halfling_monk)
  map.put("avatar_halfling_paladin", Res.drawable.avatar_halfling_paladin)
  map.put("avatar_halfling_ranger", Res.drawable.avatar_halfling_ranger)
  map.put("avatar_halfling_rogue", Res.drawable.avatar_halfling_rogue)
  map.put("avatar_halfling_sorcerer", Res.drawable.avatar_halfling_sorcerer)
  map.put("avatar_halfling_warlock", Res.drawable.avatar_halfling_warlock)
  map.put("avatar_halfling_wizard", Res.drawable.avatar_halfling_wizard)
  map.put("avatar_human_barbarian", Res.drawable.avatar_human_barbarian)
  map.put("avatar_human_bard", Res.drawable.avatar_human_bard)
  map.put("avatar_human_cleric", Res.drawable.avatar_human_cleric)
  map.put("avatar_human_druid", Res.drawable.avatar_human_druid)
  map.put("avatar_human_fighter", Res.drawable.avatar_human_fighter)
  map.put("avatar_human_monk", Res.drawable.avatar_human_monk)
  map.put("avatar_human_paladin", Res.drawable.avatar_human_paladin)
  map.put("avatar_human_ranger", Res.drawable.avatar_human_ranger)
  map.put("avatar_human_rogue", Res.drawable.avatar_human_rogue)
  map.put("avatar_human_sorcerer", Res.drawable.avatar_human_sorcerer)
  map.put("avatar_human_warlock", Res.drawable.avatar_human_warlock)
  map.put("avatar_human_wizard", Res.drawable.avatar_human_wizard)
  map.put("avatar_tiefling_barbarian", Res.drawable.avatar_tiefling_barbarian)
  map.put("avatar_tiefling_bard", Res.drawable.avatar_tiefling_bard)
  map.put("avatar_tiefling_cleric", Res.drawable.avatar_tiefling_cleric)
  map.put("avatar_tiefling_druid", Res.drawable.avatar_tiefling_druid)
  map.put("avatar_tiefling_fighter", Res.drawable.avatar_tiefling_fighter)
  map.put("avatar_tiefling_monk", Res.drawable.avatar_tiefling_monk)
  map.put("avatar_tiefling_paladin", Res.drawable.avatar_tiefling_paladin)
  map.put("avatar_tiefling_ranger", Res.drawable.avatar_tiefling_ranger)
  map.put("avatar_tiefling_rogue", Res.drawable.avatar_tiefling_rogue)
  map.put("avatar_tiefling_sorcerer", Res.drawable.avatar_tiefling_sorcerer)
  map.put("avatar_tiefling_warlock", Res.drawable.avatar_tiefling_warlock)
  map.put("avatar_tiefling_wizard", Res.drawable.avatar_tiefling_wizard)
}
